import React from 'react';
import { Card, CardContent } from '../components/ui/card';

const AGB = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <h1 className="legal-title">Allgemeine Geschäftsbedingungen (AGB)</h1>
          <p className="legal-subtitle">Pixel56 Template Club (B2B & B2C)</p>
          <p className="legal-date">Stand: 11.11.2025</p>
        </div>
        <Card className="legal-card">
          <CardContent className="legal-content">
            <section className="legal-section">
              <p>
                <strong>Anbieter:</strong> Atilla Ciftcioglu (handelnd unter „Pixel56")<br />
                Hüttenstraße 100, 56170 Bendorf<br />
                Telefon: 02622-9898654 · E-Mail: info@pixel56.de · USt-ID: DE316853316
              </p>
            </section>

            <section className="legal-section">
              <h2>1. Geltungsbereich, Begriffe</h2>
              <p>
                1.1 Diese AGB regeln den entgeltlichen Zugang zu den digitalen Inhalten des Pixel56 
                Template Club („Mitgliedschaft").
              </p>
              <p>
                1.2 Verbraucher:in i. S. d. § 13 BGB ist jede natürliche Person, die den Vertrag 
                überwiegend nicht zu gewerblichen oder selbständigen beruflichen Zwecken abschließt. 
                Unternehmer:in i. S. d. § 14 BGB ist, wer bei Vertragsschluss in Ausübung seiner 
                gewerblichen oder selbständigen beruflichen Tätigkeit handelt.
              </p>
              <p>
                1.3 Abweichende Bedingungen der Kundschaft gelten nicht, es sei denn, der Anbieter 
                stimmt ausdrücklich zu.
              </p>
            </section>

            <section className="legal-section">
              <h2>2. Leistungsbeschreibung (digitale Inhalte)</h2>
              <p>
                2.1 Bereitgestellt werden digitale Inhalte, v. a. Canva-Template-Links (u. a. 
                Social-Posts, Reels/Shorts-Cover, Story-Sequenzen, Anzeigen-Layouts, Karussell-Slides, 
                Lead-Magnet-Layouts, Checklisten, Mini-Workbooks) – zusammen „Templates".
              </p>
              <p>
                2.2 Lieferform: Zugriff über einen Mitgliederbereich (z. B. Skool) und/oder 
                Download-/Template-Links.
              </p>
              <p>
                2.3 Frequenz: Der Anbieter strebt tägliche Drops an. Inhalt, Umfang und Nischen 
                können variieren; kurzzeitige Unterbrechungen (Wartung/Feiertage/höhere Gewalt) 
                sind möglich.
              </p>
              <p>
                2.4 Support: Kurze How-to-Hinweise/Videos/FAQ. Keine Individual-/Agenturleistung 
                ohne Zusatzvereinbarung.
              </p>
            </section>

            <section className="legal-section">
              <h2>3. Registrierung, Konto, Zugriff</h2>
              <p>
                3.1 Nutzung setzt Registrierung und ggf. ein Konto im Mitgliederbereich (z. B. Skool) 
                voraus.
              </p>
              <p>
                3.2 Personalisierter Zugang (1 Sitz/Account). Team-/Mehrpersonen-Nutzung erfordert 
                zusätzliche Lizenzen/Sitze. Zugangsdaten sind vertraulich.
              </p>
              <p>
                3.3 Bei Verstößen (z. B. Lizenz-/AGB-Missbrauch) kann der Anbieter Zugänge sperren 
                oder kündigen.
              </p>
            </section>

            <section className="legal-section">
              <h2>4. Preise, Zahlung, Abwicklung</h2>
              <p>
                4.1 Preis: 79 € / Monat (sofern im Checkout nicht anders ausgewiesen), inkl./zzgl. 
                USt. gemäß Anzeige im Checkout.
              </p>
              <p>
                4.2 Zahlung & Abwicklung über den im Checkout genannten Zahlungsdienst/Plattformbetreiber 
                (z. B. Skool/Zahlungsprozessor); deren Bedingungen gelten ergänzend.
              </p>
              <p>
                4.3 Abo: Fälligkeit zu Vertragsbeginn und anschließend monatlich automatisch bis zur 
                Kündigung.
              </p>
              <p>
                4.4 Preisänderungen werden mindestens 30 Tage vorher angekündigt und gelten nur für 
                künftige Abrechnungszeiträume.
              </p>
            </section>

            <section className="legal-section">
              <h2>5. Laufzeit und Kündigung</h2>
              <p>
                5.1 Mitgliedschaft auf unbestimmte Zeit mit monatlicher Abrechnung.
              </p>
              <p>
                5.2 Kündigung jederzeit zum Ende des laufenden Abrechnungsmonats über den 
                Mitgliederbereich/Account-Einstellungen, über den online bereitgestellten 
                Kündigungsbutton (sofern Verbraucher:innen den Vertrag online schließen) oder per 
                E-Mail an info@pixel56.de.
              </p>
              <p>
                5.3 Nach Vertragsende entfällt der Zugriff auf den Mitgliederbereich und künftige 
                Drops. Ziffer 8.4 regelt die Weiternutzung bereits erhaltener Templates.
              </p>
            </section>

            <section className="legal-section">
              <h2>6. Widerruf (nur für Verbraucher:innen)</h2>
              <p>
                6.1 Bei Verträgen mit Verbraucher:innen über digitale Inhalte ohne körperlichen 
                Datenträger beginnt die Ausführung vor Ablauf der Widerrufsfrist nur, wenn die/der 
                Verbraucher:in im Checkout ausdrücklich zustimmt und bestätigt, dass das Widerrufsrecht 
                mit Beginn der Ausführung erlischt.
              </p>
              <p>
                6.2 Ohne diese Zustimmung/Bestätigung gilt das gesetzliche Widerrufsrecht; die 
                Bereitstellung startet erst nach Fristablauf.
              </p>
              <p>
                6.3 Kein freiwilliges Rückgaberecht / keine Geld-zurück-Garantie. Gesetzliche Rechte 
                bleiben unberührt.
              </p>
            </section>

            <section className="legal-section">
              <h2>7. Pflichten der Kundschaft</h2>
              <p>
                7.1 Accountschutz: Zugangsdaten geheim halten; keine Weitergabe.
              </p>
              <p>
                7.2 Rechtskonforme Nutzung: Keine rechtswidrigen, irreführenden oder schädigenden 
                Verwendungen.
              </p>
              <p>
                7.3 Plattformregeln & Steuern: Beim Verkauf eigener Produkte auf Drittplattformen 
                (z. B. Etsy, Amazon KDP, Gumroad) sind deren Richtlinien sowie eigene steuerliche 
                Pflichten einzuhalten. Der Anbieter übernimmt hierfür keine Verantwortung/Prüfung.
              </p>
            </section>

            <section className="legal-section">
              <h2>8. Nutzungsrechte (Resell-Lizenz)</h2>
              <p>
                8.1 Lizenzart: Mit aktiver Mitgliedschaft erhält ein Account eine nicht-exklusive, 
                nicht übertragbare Resell-Lizenz (Einzellizenz) an allen während der aktiven Laufzeit 
                bereitgestellten Templates.
              </p>
              <p>
                <strong>8.2 Gestattet:</strong><br />
                a) Bearbeiten, anpassen, branden.<br />
                b) Verkauf an Endkund:innen als fertige Designs (z. B. Social-Posts, PDFs) oder als 
                eigene digitale Produkte/angepasste Vorlagen.
              </p>
              <p>
                <strong>8.3 Untersagt:</strong><br />
                a) Weitergabe/Weiterverkauf der Original-Template-Links/Dateien als bloße Sammlung 
                oder in Massen-Bundles;<br />
                b) Weiterverkauf/Weitergabe der Resell-Lizenz selbst (kein PLR/MRR; keine Unterlizenzierung);<br />
                c) Auftreten, als seist du Urheber:in/Markeninhaber:in „Pixel56";<br />
                d) Nutzung etwaiger Dritt-Assets (z. B. Stock-Fotos/Schriften/Logos) ohne eigene Rechte.
              </p>
              <p>
                8.4 Nach Kündigung: Bereits während aktiver Mitgliedschaft erhaltene Templates dürfen 
                – vorbehaltlich 8.3 – zeitlich unbefristet weitergenutzt werden. Zugriff auf neue 
                Inhalte entfällt.
              </p>
              <p>
                8.5 Canva-Hinweis: Templates können Canva-Pro-Elemente enthalten; hierfür gelten die 
                Canva-Lizenzen. Ggf. ist Canva Pro erforderlich/zweckmäßig.
              </p>
            </section>

            <section className="legal-section">
              <h2>9. Geistiges Eigentum</h2>
              <p>
                9.1 Sämtliche Rechte an Inhalten, Marken, Logos und Templates verbleiben beim Anbieter 
                bzw. dessen Lizenzgebern – vorbehaltlich der in 8 gewährten Nutzungsrechte.
              </p>
              <p>
                9.2 Rechtliche Hinweise und Schutzvermerke sind zu beachten und – soweit unzulässig – 
                nicht zu entfernen.
              </p>
            </section>

            <section className="legal-section">
              <h2>10. Verfügbarkeit, Änderungen, Missbrauchsschutz</h2>
              <p>
                10.1 Der Anbieter bemüht sich um hohe Verfügbarkeit, garantiert jedoch keine bestimmte Quote.
              </p>
              <p>
                10.2 Inhalte, Struktur, Nischen und Frequenz dürfen weiterentwickelt werden, sofern der 
                Gesamtcharakter erhalten bleibt.
              </p>
              <p>
                10.3 Antimissbrauch: Der Anbieter darf technische Maßnahmen (individuelle Links, 
                Rotationen, Wasserzeichen etc.) einsetzen.
              </p>
            </section>

            <section className="legal-section">
              <h2>11. Gewährleistung und Haftung</h2>
              <p>
                11.1 Für Unternehmer:innen gelten die gesetzlichen Gewährleistungsregeln mit den 
                Einschränkungen dieser AGB; für Verbraucher:innen gelten die gesetzlichen Mängelrechte 
                für digitale Produkte. Geringe Abweichungen in Darstellung/Typografie begründen keinen Mangel.
              </p>
              <p>
                11.2 Der Anbieter haftet unbeschränkt bei Vorsatz/grober Fahrlässigkeit sowie für 
                Schäden aus Verletzung von Leben, Körper, Gesundheit.
              </p>
              <p>
                11.3 Bei einfacher Fahrlässigkeit haftet der Anbieter nur bei Verletzung wesentlicher 
                Vertragspflichten (Kardinalpflichten) und der Höhe nach beschränkt auf den vorhersehbaren, 
                vertragstypischen Schaden.
              </p>
              <p>
                11.4 Haftung für mittelbare Schäden/entgangenen Gewinn ist – soweit gesetzlich zulässig 
                – ausgeschlossen.
              </p>
            </section>

            <section className="legal-section">
              <h2>12. Datenschutz</h2>
              <p>
                Es gilt die Datenschutzerklärung des Anbieters (abrufbar auf der Website des Anbieters). 
                Bei Nutzung externer Plattformen/Zahlungsdienste gelten zusätzlich deren Datenschutzhinweise.
              </p>
            </section>

            <section className="legal-section">
              <h2>13. Schlussbestimmungen</h2>
              <p>
                13.1 Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts.
              </p>
              <p>
                13.2 Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen 
                unberührt.
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AGB;
